import React, { useState, useContext, useEffect } from 'react';

import PropTypes from 'prop-types';

import './VettingHomeAddress.css';

import VettingDropDown from '../../Common/VettingDropDown/VettingDropDown';
import VettingInput from '../../Common/VettingInput/VettingInput';
import KeyValueDataComponent from '../../CreditVetting/KeyValueDataComponent/KeyValueDataComponent';
import VettingCheckBoxPanel from '../../Common/VettingCheckBoxPanel/VettingCheckBoxPanel';
import VettingSearchBar from '../../Common/VettingSearchBar/VettingSearchBar';

import {
  SalesContext
} from "./../../../Context/SalesContext";
import {
  FormFieldLabel
} from '../../../StyledComponents';
import {
  checkInputValidity,
  getKeyValueData,
  createArray,
  getDetailedAddressObject,
  getKeyValueDataFromAddressobj,
  registerEnterEvent
} from '../../../Utility/utility';

const VettingHomeAddress = (props) => {
  const context = useContext(SalesContext);
  const homeAddress = context.vettingCreditDetails.homeAddress;
  const provinceList = context.provinceList;
  const [sameAsInstallationAddress, setSameAsInstallationAddress] = useState(context.vettingSameAsInstallationAddress);
  const [reverseGeoCodeError, setReverseGeoCodeError] = useState(null);

  const [newHomeAddress, setNewHomeAddress] = useState(getKeyValueDataFromAddressobj(context.installationAddress, context.installationAddress.unitNumber, context.installationAddress.buildingName));
  const dropDownValues = context.dropDownValues;
  const ownerTypeArray = dropDownValues.ADDRESS_RESIDENCY_TYPE.map(item => item.name);

  const fullInstallationAddress = context.installationAddress.formattedAddress;

  const [ownerType, setOwnerType] = useState({
    name: "Owner type",
    type: "dropDown",
    value: homeAddress?.ownerType?.value || "Owner",
    options: ownerTypeArray || ['Owner', 'Renting', 'Other'],
    width: 60,
    validations: {
      required: true,
      invalidMessage: "Please select your home owner status",
    },
    config: {
      type: "select",
      required: true,
      placeholder: "Select owner type",
      tabIndex: "33"
    },
    isValid: true,
    isTouched: true
  })

  const [formData, setFormData] = useState({
    // Form Fields
    formComponents: {
      searchBar: {
        name: "Search Address",
        type: "search",
        value: homeAddress?.searchBar?.value || fullInstallationAddress || "",
        width: 100,
        validations: {
          required: false,
          invalidMessage: "",
        },
        config: {
          type: "search",
          required: false,
          placeholder: "Search address",
          tabIndex: "30"
        },
        isValid: true,
        isTouched: true
      },
      unitNumber: {
        name: "Unit no.",
        type: "input",
        optional: true,
        value: homeAddress?.unitNumber?.value || newHomeAddress?.unitNumber?.value || "",
        width: 30,
        validations: {
          required: false,
          invalidMessage: "Please enter a valid cell phone number",
        },
        config: {
          type: "text",
          required: true,
          placeholder: "0000",
          tabIndex: "31"
        },
        isValid: true,
        isTouched: true
      },
      buildingName: {
        name: "Building name",
        type: "input",
        optional: true,
        value: homeAddress?.buildingName?.value || newHomeAddress?.unitNumber?.value || "",
        width: 65,
        validations: {
          required: false,
          invalidMessage: "Please enter a valid building name address",
        },
        config: {
          type: "text",
          required: true,
          placeholder: "Enter complex name",
          tabIndex: "32",
          maxLength: 30
        },
        isValid: true,
        isTouched: true
      },
      ownerType: {
        name: "Owner type",
        type: "dropDown",
        value: homeAddress?.ownerType?.value || "Owner",
        options: ownerTypeArray || ['Owner', 'Renting', 'Other'],
        width: 100,
        validations: {
          required: true,
          invalidMessage: "Please select your home owner status",
        },
        config: {
          type: "select",
          required: true,
          placeholder: "Select owner type",
          tabIndex: "33"
        },
        isValid: true,
        isTouched: true
      },
      streetNo: {
        name: "Street no.",
        type: "input",
        value: homeAddress?.streetNo?.value || newHomeAddress?.streetNo?.value || "",
        width: 30,
        validations: {
          required: true,
          invalidMessage: "Please enter your street number",
        },
        config: {
          type: "text",
          required: true,
          placeholder: "Street no.",
          tabIndex: "34"
        },
        isValid: false,
        isTouched: false
      },
      streetName: {
        name: "Street name",
        type: "input",
        value: homeAddress?.streetName?.value || newHomeAddress?.streetName?.value || "",
        width: 65,
        validations: {
          required: true,
          invalidMessage: "Please enter your street name",
        },
        config: {
          type: "text",
          required: true,
          placeholder: "Enter street name",
          tabIndex: "35"
        },
        isValid: false,
        isTouched: false
      },
      suburb: {
        name: "Suburb",
        type: "input",
        value: homeAddress?.suburb?.value || newHomeAddress?.suburb?.value || "",
        width: 65,
        validations: {
          required: true,
          invalidMessage: "Please enter your suburb",
        },
        config: {
          type: "text",
          required: true,
          placeholder: "Enter Suburb",
          tabIndex: "36"
        },
        isValid: false,
        isTouched: false
      },
      postalCode: {
        name: "Postal code",
        type: "input",
        value: homeAddress?.postalCode?.value || newHomeAddress?.postalCode?.value || "",
        width: 30,
        validations: {
          required: true,
          type: "number",
          minLength: 4,
          maxLength: 5,
          invalidMessage: "Please enter valid postal code",
        },
        config: {
          type: "text",
          required: true,
          placeholder: "Postal code",
          tabIndex: "37"
        },
        isValid: false,
        isTouched: false
      },
      town: {
        name: "Town/City",
        type: "input",
        value: homeAddress?.town?.value || newHomeAddress?.town?.value || "",
        width: 100,
        validations: {
          required: true,
          invalidMessage: "Please enter your town/city",
        },
        config: {
          type: "text",
          required: true,
          placeholder: "Enter town/city",
          tabIndex: "38"
        },
        isValid: false,
        isTouched: false
      },
      province: {
        name: "Province",
        type: "dropDown",
        value: homeAddress?.province?.value || newHomeAddress?.province?.value || "",
        options: provinceList,
        width: 100,
        validations: {
          required: true,
          invalidMessage: "Please select your province",
        },
        config: {
          type: "select",
          required: true,
          placeholder: "Select province",
          tabIndex: "39"
        },
        isValid: false,
        isTouched: false
      },
    },
    isFormValid: false
  });

  // Create array
  const formCompArray = createArray(formData.formComponents);
  registerEnterEvent();

  const formComponentChangeHandler = (event, inputIdentifier) => {
    if(sameAsInstallationAddress){
      if(inputIdentifier === "ownerType"){
        let newOwnerType = {...ownerType};
        newOwnerType.value = event;
        setOwnerType(newOwnerType);
        props.toggleNext(true); 
        return;
      }
    } else {
      const formCompsCopy = { ...formData.formComponents };
      const changedComponent = { ...formCompsCopy[inputIdentifier] };
      changedComponent.value = event;

      if (changedComponent.validations.type === "number") {
        let lastChar = changedComponent.value.slice(-1);
        if (isNaN(lastChar)) {
          return false;
        }
      }

      changedComponent.isValid = checkInputValidity(
        changedComponent.value,
        changedComponent.validations
      );

      changedComponent.isTouched = true;

      const changedComponent2 = { ...formCompsCopy['searchBar'] };
      if (inputIdentifier !== 'searchBar'
        && inputIdentifier !== 'unitNumber'
        && inputIdentifier !== 'buildingName'
        && inputIdentifier !== 'ownerType'
      ) {
        changedComponent2.value = "";
      }

      if (inputIdentifier === "country" && event.toLowerCase() !== "south africa") {
        formCompsCopy['province'].type = "input";
        formCompsCopy['province'].config.type = "text"
      } else {
        formCompsCopy['province'].type = "dropDown";
        formCompsCopy['province'].config.type = "select"
      }

      const newFormComps = {
        ...formCompsCopy,
        [inputIdentifier]: changedComponent,
        searchBar: inputIdentifier == 'searchBar' ? changedComponent : changedComponent2
      }

      const isFormValid = !Object.keys(newFormComps).find(e => newFormComps[e].isValid === false) ? true : false;

      setFormData({
        formComponents: newFormComps,
        isFormValid: isFormValid
      });

      if (isFormValid) {
        props.toggleNext(true);
      } else {
        props.toggleNext(false);
      }
    }
  };

  const saveDetails = () => {
    let keyValueData;
    if (sameAsInstallationAddress) {
      keyValueData = {
        ...getKeyValueDataFromAddressobj(context.installationAddress, context.installationAddress.unitNumber, context.installationAddress.buildingName),
        ownerType: {
          label: "Owner Type",
          value: ownerType.value
        }
      }
    } else {
      keyValueData = getKeyValueData(formData.formComponents);
    }
    context.setVettingDetails('homeAddress', keyValueData);
    props.onNextClick(keyValueData);
  }

  const updateNewHomeAddress = async (address) => {
    formComponentChangeHandler(address, 'searchBar');
    context.setShowSpinner(true);
    getDetailedAddressObject(address)
      .then(res => {
        setNewHomeAddress(getKeyValueDataFromAddressobj(res));
        context.setShowSpinner(false);
        setReverseGeoCodeError(null);
      })
      .catch(_err => {
        setNewHomeAddress(null);
        context.setShowSpinner(false);
        setReverseGeoCodeError("Unable to pre-populate the vaules please enter manually.");
      })
  }

  useEffect(() => {
    const formCompsCopy = { ...formData.formComponents };
    for (let key in newHomeAddress) {
      if (newHomeAddress[key] === "")
        continue;

      const changedComponent = { ...formCompsCopy[key] };
      if (Object.keys(changedComponent).length !== 0) {
        changedComponent.value = newHomeAddress[key].value;

        changedComponent.isValid = checkInputValidity(
          changedComponent.value,
          changedComponent.validations
        );

        changedComponent.isTouched = true;

        formCompsCopy[key] = changedComponent;
      }
    }

    const isFormValid = !Object.keys(formCompsCopy).find(e => formCompsCopy[e].isValid === false) ? true : false;
    setFormData({
      formComponents: formCompsCopy,
      isFormValid: isFormValid
    });

    if (sameAsInstallationAddress) {
      props.toggleNext(true);
    } else {
      if (isFormValid) {
        props.toggleNext(true);
      } else {
        props.toggleNext(false);
      }
    }

  }, [newHomeAddress, props.isEditModeOn])

  return (
    <React.Fragment>
      <div className="vetting-main-section-wrapper">
        {
          homeAddress && !props.isEditModeOn ?
            <KeyValueDataComponent data={homeAddress} />
            :
            <React.Fragment>
              <VettingCheckBoxPanel
                value={sameAsInstallationAddress}
                label={`
                  <div>My home address is the same as my <span class="bold-font">installation address</span></div>
                  <div class="vetting-installation-address">${fullInstallationAddress}</div>
                `}
                inputIdentifier={'installationAddress'}
                onChange={(value) => {
                  setSameAsInstallationAddress(value);
                  context.setVettingSameAsInstallationAddress(value);
                  if(value) {
                    props.toggleNext(value);
                  }
                }}
              />
              <div className="vetting-pd-wrapper" style={{ marginTop: "2em" }}>
                {
                  !sameAsInstallationAddress && formCompArray.map(item => {
                    return (
                      <div className={`input-field-wrapper-${item.config.width}`} key={item.key}>
                        {
                          item.config.type === "search" ?
                            formData?.formComponents?.country?.value?.toLowerCase() === "south africa" ?
                              <FormFieldLabel
                                hide={item?.config?.hideLabel}
                                automationidattr={`homeAddress${item.config.name}`}
                              >
                                {item.config.name}
                                {
                                  item?.config?.optional && <span className="vetting-optional-text"> (Optional)</span>
                                }
                              </FormFieldLabel>
                              :
                              // Revert if country scenario back
                              <FormFieldLabel
                                hide={item?.config?.hideLabel}
                                automationidattr={`homeAddress${item.config.name}`}
                              >
                                {item.config.name}
                                {
                                  item?.config?.optional && <span className="vetting-optional-text"> (Optional)</span>
                                }
                              </FormFieldLabel>
                            :
                            <FormFieldLabel
                              hide={item?.config?.hideLabel}
                              automationidattr={`homeAddress${item.config.name}`}
                            >
                              {item.config.name}
                              {
                                item?.config?.optional && <span className="vetting-optional-text"> (Optional)</span>
                              }
                            </FormFieldLabel>
                        }

                        {
                          item.config.type === "input" ?
                            <VettingInput
                              {...item.config}
                              updateValue={formComponentChangeHandler}
                              inputIdentifier={item.key}
                              automationidattr={`homeAddress`}
                            />
                            :
                            null
                        }
                        {
                          item.config.type === "dropDown" ?
                            <VettingDropDown
                              selectedValue={item.config.value}
                              placeholder={item.config.config.placeholder}
                              options={item.config.options}
                              updateSelectedOption={formComponentChangeHandler}
                              inputIdentifier={item.key}
                              automationidattr={`homeAddress`}
                            />
                            :
                            null
                        }
                        {
                          (item.config.type === "search" ) ?
                            <VettingSearchBar
                              value={item.config.value}
                              inputIdentifier={item.key}
                              updateValue={formComponentChangeHandler}
                              onAddressSelection={updateNewHomeAddress}
                              automationidattr={`homeAddress`}
                              errorMsg={reverseGeoCodeError}
                            />
                            :
                            null
                        }
                      </div>
                    )
                  })
                }
              </div>
              {
                sameAsInstallationAddress && 
                <div className={`input-field-wrapper-${ownerType.width}`}>
                  <FormFieldLabel
                    hide={ownerType?.hideLabel}
                    automationidattr={`homeAddress${ownerType.name}`}
                  >
                    {ownerType.name}
                    {
                      ownerType?.optional && <span className="vetting-optional-text"> (Optional)</span>
                    }
                  </FormFieldLabel>
                  <VettingDropDown
                    selectedValue={ownerType.value}
                    placeholder={ownerType.config.placeholder}
                    options={ownerType.options}
                    updateSelectedOption={formComponentChangeHandler}
                    inputIdentifier={'ownerType'}
                    automationidattr={`homeAddress`}
                  />
                </div>
                
              }
              {
                props.showBody ?
                  <div className="vetting-next-wrapper">
                    <button
                      className={`vetting-section-next-button ${props.enableNext ? 'next-enabled' : ''}`}
                      onClick={() => saveDetails()}
                      disabled={props.enableNext ? '' : 'disabled'}
                      automationid={`SalesLead_button_homeAddressNextBtn_1"`}
                    >
                      Next
                    </button>
                  </div>
                  :
                  null
              }
            </React.Fragment>
        }
      </div>

    </React.Fragment>
  )
}

VettingHomeAddress.propTypes = {
  enableNext: PropTypes.bool,
  isEditModeOn: PropTypes.bool,
  onNextClick: PropTypes.func,
  showBody: PropTypes.bool,
  toggleNext: PropTypes.func,
}

export default VettingHomeAddress;